import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import {addPopup, getUserData} from "../../redux/actions";
import * as popups from "../../constants/popup-types";


class DeleteTokenRequest extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'Delete Token Request';
        this.Config   = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.deleteToken, payload);
    }

    // custom on failure
    onFailure(response, methodName = ''){
        this.dispatch(addPopup({
            type:popups.GENERAL_MESSAGE,
            text: response.err.content,
            popup_id: Math.round(Math.random() * 1000000),
        }));
    }

    //Parse successful response
    onSuccess() {
        this.dispatch(getUserData());
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {

    }

}


export default DeleteTokenRequest;